export default __webpack_public_path__ + "images/FGLOGO_white.47cf47bf24262dce13025cdcd97f9e41.svg"